import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiTranslation } from "../../../i18n";
import { cn } from "../../../lib/utils";
import { ChatFrameHeader } from "./ChatFrameHeader";
import { PortalRootProvider } from "../overlays/portalRootContext";
const renderSlot = (slot, props) => {
    if (!slot)
        return null;
    if (typeof slot === "function") {
        return slot(props);
    }
    return slot;
};
export const ChatFrame = ({ title, newLabel, closeLabel, className, contentClassName, header, input, children, portalRoot, onNew, onClose, }) => {
    const { t } = useUiTranslation();
    const resolvedTitle = title ?? t("chat.title");
    const resolvedNewLabel = newLabel ?? t("chat.newChat");
    const resolvedCloseLabel = closeLabel ?? t("chat.close");
    const headerSlotProps = {
        className: "flex items-center gap-2 border-b px-4 py-3",
        title: resolvedTitle,
        newLabel: resolvedNewLabel,
        isNewDisabled: !onNew,
        closeLabel: resolvedCloseLabel,
        onNew: () => onNew?.(),
        onClose,
    };
    const inputSlotProps = {
        className: "border-t px-4 py-3",
        disabled: false,
    };
    const renderedHeader = renderSlot(header, headerSlotProps);
    const renderedInput = renderSlot(input, inputSlotProps);
    return (_jsx(PortalRootProvider, { portalRoot: portalRoot ?? null, children: _jsxs("div", { className: cn("flex min-h-0 flex-1 flex-col overflow-hidden", className), children: [renderedHeader ?? _jsx(ChatFrameHeader, { ...headerSlotProps }), _jsx("div", { className: cn("min-h-0 flex-1 overflow-auto", contentClassName), children: children }), input
                    ? typeof input === "function"
                        ? renderedInput
                        : renderedInput && (_jsx("div", { className: inputSlotProps.className, children: renderedInput }))
                    : null] }) }));
};
//# sourceMappingURL=ChatFrame.js.map